window.MetaPixelEvents = {
  track(eventName, params) {
    if (typeof fbq !== 'function') return;
    fbq('track', eventName, params || {});
  },

  centsToValue(cents) {
    return Number((Number(cents) / 100).toFixed(2));
  },

  itemParams(item) {
    const variantId = item.variant_id || item.id;
    const price = item.final_price ?? item.price ?? 0;
    const quantity = item.quantity || 1;

    return {
      content_ids: [String(variantId)],
      content_type: 'product',
      content_name: item.product_title || item.title || '',
      value: this.centsToValue(price * quantity),
      currency: item.currency || 'USD',
      contents: [
        {
          id: String(variantId),
          quantity,
          item_price: this.centsToValue(price)
        }
      ]
    };
  },

  cartParams(cart) {
    const items = Array.isArray(cart?.items) ? cart.items : [];

    return {
      content_ids: items.map((item) => String(item.variant_id)),
      content_type: 'product',
      contents: items.map((item) => ({
        id: String(item.variant_id),
        quantity: item.quantity,
        item_price: this.centsToValue(item.final_price || item.price)
      })),
      num_items: items.reduce((sum, item) => sum + (item.quantity || 0), 0),
      value: this.centsToValue(cart?.total_price || 0),
      currency: cart?.currency || 'USD'
    };
  },

  orderParams(order) {
    const items = Array.isArray(order?.items) ? order.items : [];

    return {
      content_ids: items.map((item) => String(item.variant_id || item.id)).filter(Boolean),
      content_type: 'product',
      contents: items.map((item) => ({
        id: String(item.variant_id || item.id),
        quantity: item.quantity,
        item_price: this.centsToValue(item.final_price || item.price)
      })),
      num_items: items.reduce((sum, item) => sum + (item.quantity || 0), 0),
      value: this.centsToValue(order?.total || 0),
      currency: order?.currency || 'USD'
    };
  },

  trackViewContent({ variantId, name, value, currency }) {
    this.track('ViewContent', {
      content_ids: [String(variantId)],
      content_type: 'product',
      content_name: name || '',
      value: this.centsToValue(value),
      currency: currency || 'USD'
    });
  },

  trackAddToCart(itemOrCart) {
    if (itemOrCart?.items) {
      this.track('AddToCart', this.cartParams(itemOrCart));
      return;
    }

    this.track('AddToCart', this.itemParams(itemOrCart));
  },

  trackInitiateCheckout(cart) {
    this.track('InitiateCheckout', this.cartParams(cart));
  },

  trackPurchase(order) {
    this.track('Purchase', this.orderParams(order));
  },

  purchaseStorageKey(orderRef) {
    return `pepx_pixel_purchase_${orderRef}`;
  },

  trackPurchaseOnce(order) {
    const orderRef = order?.orderRef || '';
    if (!orderRef) {
      this.trackPurchase(order);
      return;
    }

    const key = this.purchaseStorageKey(orderRef);
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch {
      // Ignore storage errors and still attempt to track.
    }

    this.trackPurchase(order);
  }
};
